import React, { ChangeEvent, useEffect, useState } from 'react';
import { Text, DropDown } from 'library';
import { client, consoleLogInDev } from 'shared';
import { emptyProvider, PastProvider } from './models';

const ReferProvider = ({
    referredProvider,
    updateReferredProvider,
}: {
    referredProvider: PastProvider;
    updateReferredProvider: (provider: PastProvider) => void;
}) => {
    const [providers, setProviders] = useState<PastProvider[]>([]);

    const getPastProviders = () => {
        client('get-past-sitters/')
            .then((result: { past_sitters: PastProvider[] }) => {
                let providerList = result.past_sitters;
                if (
                    referredProvider.id > 0 &&
                    !result.past_sitters.find((sitter) => sitter.id === referredProvider.id)
                ) {
                    providerList.push(referredProvider);
                }
                providerList.splice(0, 0, emptyProvider);
                setProviders(providerList);
                consoleLogInDev(providers.length);
            })
            .catch(consoleLogInDev);
    };

    useEffect(getPastProviders, []);

    const mapToDropDownEntries = () =>
        providers?.map((provider) => ({ value: `${provider.first_name} ${provider.last_name}`, key: provider.id }));

    const onChangeProvider = (event: ChangeEvent<{ value: number }>) => {
        updateReferredProvider(providers?.find((provider) => provider.id === event.target.value) || emptyProvider);
    };

    return (
        <>
            {providers.length > 1 ? (
                <div style={{ marginBottom: 10, padding: 5 }}>
                    <Text bold variant="body1">
                        Refer a past provider to a friend
                    </Text>
                    <DropDown
                        fields={mapToDropDownEntries()}
                        selected={referredProvider.id}
                        onChange={onChangeProvider}
                    ></DropDown>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default ReferProvider;
